import { warn } from './log';
import { translateForLookup, translateMapForLookup } from './translate';

export enum EquipmentType {
  App = 'App',
  Bike = 'Bike',
  Elliptical = 'Elliptical',
  Equipmentless = 'Equipmentless',
  FreeStrider = 'FreeStrider',
  Fusion = 'Fusion',
  InclineTrainer = 'Incline Trainer',
  Mirror = 'Mirror',
  None = 'None',
  Rower = 'Rower',
  Shoes = 'Shoes',
  SpinBike = 'SpinBike',
  StationaryBike = 'Stationary Bike',
  Stepper = 'Stepper',
  Strength = 'Strength',
  Strider = 'Strider',
  StudioBike = 'Studio Bike',
  TDFBike = 'TDF Bike',
  Treadmill = 'Treadmill',
  Vault = 'Vault',
  VerticalElliptical = 'VerticalElliptical',
  VibrationPlatform = 'Vibration Platform',
  Wearable = 'wearable',
}

const map = translateMapForLookup<EquipmentType>({
  [EquipmentType.App]: EquipmentType.App,
  [EquipmentType.Bike]: EquipmentType.Bike,
  [EquipmentType.Elliptical]: EquipmentType.Elliptical,
  [EquipmentType.Equipmentless]: EquipmentType.Equipmentless,
  [EquipmentType.FreeStrider]: EquipmentType.FreeStrider,
  [EquipmentType.Fusion]: EquipmentType.Fusion,
  [EquipmentType.InclineTrainer]: EquipmentType.InclineTrainer,
  [EquipmentType.Mirror]: EquipmentType.Mirror,
  [EquipmentType.None]: EquipmentType.None,
  [EquipmentType.Rower]: EquipmentType.Rower,
  [EquipmentType.Shoes]: EquipmentType.Shoes,
  [EquipmentType.SpinBike]: EquipmentType.SpinBike,
  [EquipmentType.StationaryBike]: EquipmentType.StationaryBike,
  [EquipmentType.Stepper]: EquipmentType.Stepper,
  [EquipmentType.Strength]: EquipmentType.Strength,
  [EquipmentType.Strider]: EquipmentType.Strider,
  [EquipmentType.StudioBike]: EquipmentType.StudioBike,
  [EquipmentType.TDFBike]: EquipmentType.TDFBike,
  [EquipmentType.Treadmill]: EquipmentType.Treadmill,
  [EquipmentType.Vault]: EquipmentType.Vault,
  [EquipmentType.VerticalElliptical]: EquipmentType.VerticalElliptical,
  [EquipmentType.VibrationPlatform]: EquipmentType.VibrationPlatform,
  [EquipmentType.Wearable]: EquipmentType.Wearable,
});

export function parseEquipmentType(type: EquipmentType | string): EquipmentType {
  const retVal = map[translateForLookup(type as EquipmentType)];
  if (retVal) {
    return retVal;
  }
  warn(`Unexpected equipmentType passed to parseEquipmentType: ${type}, falling back to Strength.`);
  return EquipmentType.Strength;
}
